let cryptoKey = null; // AES-GCM key, set after the passphrase is entered
export const getKey = () => cryptoKey;
export const setKey = (k) => { cryptoKey = k; };

const _enc = new TextEncoder();
const _dec = new TextDecoder();
const _b64 = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)));
const _unb64 = (str) => Uint8Array.from(atob(str), c => c.charCodeAt(0));

export async function deriveKey(passphrase) {
  const base = await crypto.subtle.importKey(
    'raw', _enc.encode(passphrase), 'PBKDF2', false, ['deriveKey']);
  return crypto.subtle.deriveKey(
    { name: 'PBKDF2', salt: _enc.encode('medcalc-e2e-v1'), iterations: 150000, hash: 'SHA-256' },
    base,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt', 'decrypt']
  );
}
export async function encryptObj(obj) {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const ct = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv }, cryptoKey, _enc.encode(JSON.stringify(obj)));
  return { ciphertext: _b64(ct), iv: _b64(iv) };
}
export async function decryptObj(ciphertext, iv) {
  const pt = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: _unb64(iv) }, cryptoKey, _unb64(ciphertext));
  return JSON.parse(_dec.decode(pt));
}

// ----- remembered key in IndexedDB (non-extractable; safer than a plaintext passphrase) -----
const IDB_DB = 'medcalc', IDB_STORE = 'keys', IDB_KEY = 'aesKey';
function idbOpen() {
  return new Promise((res, rej) => {
    const r = indexedDB.open(IDB_DB, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(IDB_STORE);
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}
export async function idbPutKey(key) { const db = await idbOpen(); return new Promise((res, rej) => { const tx = db.transaction(IDB_STORE, 'readwrite'); tx.objectStore(IDB_STORE).put(key, IDB_KEY); tx.oncomplete = () => res(); tx.onerror = () => rej(tx.error); }); }
export async function idbGetKey() { const db = await idbOpen(); return new Promise((res, rej) => { const tx = db.transaction(IDB_STORE, 'readonly'); const g = tx.objectStore(IDB_STORE).get(IDB_KEY); g.onsuccess = () => res(g.result || null); g.onerror = () => rej(g.error); }); }
export async function idbClearKey() { try { const db = await idbOpen(); return await new Promise((res, rej) => { const tx = db.transaction(IDB_STORE, 'readwrite'); tx.objectStore(IDB_STORE).delete(IDB_KEY); tx.oncomplete = () => res(); tx.onerror = () => rej(tx.error); }); } catch (e) {} }
